import { IPage } from '@types'
import ContactsView from 'components/contacts/ContactsView'
import Layout from 'components/layouts/Layout'
import { generateStaticProps } from 'lib/generateStaticProps'
import { assocPath } from 'lib/utils'
import { GetStaticPropsContext, InferGetStaticPropsType } from 'next'

export let getStaticProps = async (ctx: GetStaticPropsContext) => {
  let result = await generateStaticProps(ctx, 'contacts')

  return assocPath(
    'props.contentSplitted',
    result.props.content?.split('<!--divider-->'),
    result
  )
}

export type ContactsPageProps = InferGetStaticPropsType<
  typeof getStaticProps
> & { contentSplitted: string[] }

let ContactsPage: IPage<ContactsPageProps> = ({
  contentSplitted,
  name,
}) => <ContactsView content={contentSplitted} name={name} />

ContactsPage.getLayout = (page: { props: ContactsPageProps }) => (
  <Layout
    index
    title={page.props.title || 'Контакты'}
    description={page.props?.description}
    keywords={page.props?.keywords}
  >
    {page}
  </Layout>
)

export default ContactsPage
